const status = {
    authError:419,
    entityError:422
}

export default {
    status
}